import { Controller } from '@hotwired/stimulus';
import { fireChangeEvent } from '../search/accordion_change';

export default class CheckboxController extends Controller {
  static values = {
    label: String,
  };

  connect() {
    fireChangeEvent(this.element, this._getDisplayText());
  }

  onChange() {
    fireChangeEvent(this.element, this._getDisplayText());
  }

  _getDisplayText() {
    return this.element.checked ? this.labelValue || '' : '';
  }
}
